<template>
  <div class="page-wrapper">
    <div class="stepper-header">
      <v-img alt="Step Logo" class="step1-image step-logo"/>
      <span class="reg-titre1" v-html="title"></span>
    </div>

    <v-form ref="USER" lazy-validation>
      <div
          id="register-field-container"
          :class="dialog ? 'p-0 p-md-3' : 'py-2'"
          style="width:200px;"
      >
        <user-prenom
            ref="PRENOM"
            v-model:value="prenom"
            :theme="theme"
            :show-missing="showMissing"
            :min="3"
            :max="25"
            :required="true"
            :context-id="user.id"
            :read-only="false"
            :obj-type="objType"
            :fiche="fiche"
            class="custom-fieldS1"
            :section-name="sectionName"
            @status="statusPrenom"
        />

        <user-nom
            ref="NOM"
            v-model:value="nom"
            :theme="theme"
            class="custom-fieldS1"
            :show-missing="showMissing"
            :min="3"
            :max="25"
            :required="true"
            :context-id="user.id"
            :read-only="false"
            :obj-type="objType"
            :fiche="fiche"
            :section-name="sectionName"
            @status="statusNom"
        />
      </div>
    </v-form>

    <section-container
        v-if="dialogOpen"
        :dialog-open="dialogOpen"
        :extended="true"
        :section="section"
        @updated="cguAccepted"
        @close-dialog="closeDialog"
    />
  </div>
  
  <div class="action-footer">
    <loader-button
        :label="precedentBtnTxt"
        :outlined="true"
        @callback="previous"
    />
    <loader-button
        :label="suivantBtnTxt"
        :loading="loading"
        @callback="next"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import CrudUser from '@/generated/cruds/CrudUser.ts';
import { Sections } from '@/generated/classes/AppSchema.ts';
import {AppButtons, AppCustoms, RessourceAppButton, RessourceAppCustom} from "@/ressources/globalRessources.ts";
import SectionContainer from "@/framework/base/components/SectionContainer.vue";
import SectionCgu from "@/custom/sections/SectionCgu.vue";
import User from "@/generated/classes/User.ts";
import Section from "@/framework/base/classes/Section.ts";

export default defineComponent({
  components: {
    SectionContainer
  },
  extends:  CrudUser,
  props: {
    user: {
      type: Object as PropType<User>,
      required: true
    }
  },

  data() {
    return {
      sectionName: Sections.USER,
      dialogOpen: false,
      loading: false
    }
  },
  computed: {
    title(): string {
      return RessourceAppCustom(AppCustoms.REGISTER_ETAPE1_LABEL).label;
    },
    suivantBtnTxt(): string {
      return RessourceAppButton(AppButtons.SUIVANT).label;
    },
    precedentBtnTxt(): string {
      return RessourceAppButton(AppButtons.PRECEDENT).label;
    },
    section(): Section {
      const section = new Section();
      section.component = SectionCgu;
      return section;
    },
  },
  methods: {
    cguAccepted(): void {
      this.user.cguAcceptedAt = new Date();
      this.loading = false;
      this.closeDialog();
      this.$emit('next');
    },
    previous() {
      this.$emit('previous');
    },
    next() {
      if (this.checkFields()) {
        this.loading = true;
        if (!this.user.cguAcceptedAt) {
          this.dialogOpen = true;
        } else {
          this.loading = false;
          this.$emit('next');
        }
      }
    }
  }
})
</script>

